/* eslint-disable */
import * as React from "react";

import { ReportRenderer, useParameter } from "../../../shared";
import { ReportToolbarGroup } from "../../../components/ReportToolbar";
import { ReportGrid } from "../../../components/ReportGrid";

import { CommoditiesControl } from "../controls/CommoditiesControl";
import { UnitsControl } from "../controls/UnitsControl";
import { FrequencyControl } from "../controls/FrequencyControl";

import { useSubscription } from "./useSubscription";

export default function () {
  const [commodity] = useParameter<number>("@commodities");

  useSubscription();
  return (
    <>
      <ReportToolbarGroup>
        <CommoditiesControl />
        <UnitsControl key={commodity || undefined} />
        <FrequencyControl />
      </ReportToolbarGroup>
      <div style={{ display: "none" }}>
        <ReportGrid>
          <ReportRenderer componentId="chart-growth" />
          <ReportRenderer componentId="chart-historical" />
        </ReportGrid>
      </div>
    </>
  );
}
